import React from "react";
import { Form, Input } from "antd";

/**
 * Универсальное поле с валидацией.
 *
 * Props:
 * - label         : string                — подпись поля
 * - type          : string = "text"       — тип инпута (text, email и т.п.)
 * - placeholder   : string
 * - value         : string
 * - onChange      : (e) => void
 * - onBlur        : () => void
 * - state         : "initial" | "typing" | "error" | "success"
 * - message       : string                — текст подсказки/ошибки под полем
 * - name          : string
 * - autoComplete  : string                — например "name" | "email"
 * - className     : string                — стили Tailwind/кастомные
 * - required      : boolean               — звёздочка у label
 * - showSuccess   : boolean               — показывать зелёный статус при success
 * - extra         : ReactNode             — дополнительный текст под полем
 * - prefix/suffix/addonBefore/addonAfter : ReactNode — как в AntD Input
 * - disabled/readOnly/allowClear/maxLength/onPressEnter — прокидываются в Input
 */
const ValidatedInput = ({
                            label,
                            type = "text",
                            placeholder,
                            value,
                            onChange,
                            onBlur,
                            state = "initial",
                            message,
                            name,
                            autoComplete,
                            className,
                            required = false,
                            showSuccess = false,
                            extra,
                            prefix,
                            suffix,
                            addonBefore,
                            addonAfter,
                            disabled = false,
                            readOnly = false,
                            allowClear = false,
                            maxLength,
                            onPressEnter,
                            id, // опционально, если хочешь связать label и input
                        }) => {
    const status =
        state === "error" ? "error" : showSuccess && state === "success" ? "success" : undefined;

    return (
        <Form.Item
            label={label}
            required={required}
            validateStatus={status}
            help={message || undefined}
            extra={extra}
            hasFeedback={!!status && showSuccess}
        >
            <Input
                id={id}
                type={type}
                name={name}
                autoComplete={autoComplete}
                placeholder={placeholder}
                value={value}
                onChange={onChange}
                onBlur={onBlur}
                className={className || "h-[44px] rounded-[12px]"}
                aria-invalid={state === "error"}
                prefix={prefix}
                suffix={suffix}
                addonBefore={addonBefore}
                addonAfter={addonAfter}
                disabled={disabled}
                readOnly={readOnly}
                allowClear={allowClear}
                maxLength={maxLength}
                onPressEnter={onPressEnter}
            />
        </Form.Item>
    );
};

export default ValidatedInput;
